var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.316 11.059a11.782 11.782 0 005.125 5.125l1.711-1.71c.21-.21.521-.28.794-.187a8.874 8.874 0 002.776.443.78.78 0 01.778.778v2.714a.78.78 0 01-.778.778C11.42 19 5.5 13.081 5.5 5.778A.78.78 0 016.278 5H9a.78.78 0 01.778.778c0 .972.155 1.905.443 2.776a.78.78 0 01-.194.794l-1.711 1.71z"
  })));
}

export default SvgPhoneSmall;